import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { BrandColors } from '../../constants/brandColors';

export const RatingQuestionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      minHeight: 'calc(100vh - 2.5rem)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      background: theme.palette.background.default,
      '& .itemLabel1': {
        direction: 'ltr !important',
        [theme.breakpoints.down('sm')]: {
          width: '3.562rem',
        },
      },
      '& .itemLabel5': {
        direction: 'rtl !important',
        [theme.breakpoints.down('sm')]: {
          width: '3.5rem',
          marginLeft: '-0.43rem',
        },
      },
      '& .itemLabel6': {
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      '& .itemLabel0': {
        display: 'none !important',
      },
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 3.125rem)',
      },
    },
    content: {
      width: '100%',
      minWidth: '200px',
      [theme.breakpoints.up('md')]: {
        maxWidth: '764px',
      },
    },
    questionBox: {
      width: '100%',
      position: 'relative',
      height: '100%',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        minHeight: 'calc(100vh - 246px)',
      },
    },
    section: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      padding: '3.875rem 3.625rem 2.25rem 3.5rem',
      [theme.breakpoints.up('sm')]: {
        paddingBottom: '2.75rem',
        paddingTop: '2.25rem',
      },
    },
    sectionText: {
      flexGrow: 1,
      height: 'max-content',
      '& > h6': {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        fontSize: '1.125rem',
        lineHeight: '1.563rem',
      },
    },
    sectionHelp: {
      height: 'max-content',
      color: theme.palette.default?.main,
      position: 'absolute',
      right: '0.5rem',
      padding: '0 1rem',
      [theme.breakpoints.up('sm')]: {
        padding: '0rem',
      },
      '& svg': {
        width: '1.688rem',
        height: '1.688rem',
      },
    },
    questionText: {
      padding: '0rem 1.688rem 0rem 1.75rem',
      fontSize: '1.5rem',
      fontWeight: 400,
      '& > h5': {
        color: theme.palette.default?.main || BrandColors.black,
      },
    },
    questionDesc: {
      padding: '1rem 1.063rem 2rem',
      [theme.breakpoints.up('md')]: {
        padding: '1rem 1.875rem 0',
      },
      '& > h6': {
        fontSize: '0.875rem',
        color: theme.palette.default?.main || BrandColors.black,
        fontWeight: 'normal',
        [theme.breakpoints.up('md')]: {
          fontSize: '1.125rem',
          lineHeight: '140%',
        },
      },
    },
    answerBlock: {
      display: 'grid',
      gridAutoFlow: 'column',
      gridGap: '0.75rem',
      paddingTop: '2rem',
      paddingInline: '1rem',
      overflow: 'hidden',
      [theme.breakpoints.up('sm')]: {
        gridGap: '1.875rem',
        paddingTop: '2.75rem',
        display: '-ms-flexbox',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '375px',
        margin: '0 auto',
      },
      '@media screen and (-ms-high-contrast:active), (-ms-high-contrast:none)': {
        display: '-ms-flexbox',
      },
    },
    divider: {
      width: '2px',
      height: '55px',
      marginRight: '11px',
      margin: 'auto',
      marginTop: 0,
      background: theme.palette.default?.main,
      opacity: 0.3,
      [theme.breakpoints.up('md')]: {
        marginLeft: '-0.625rem',
        marginRight: '1.25rem',
        marginTop: 0,
        height: '100%',
        '@media screen and (-ms-high-contrast: none)': {
          marginRight: '0.625rem !important',
          marginLeft: '-0.3125rem !important',
        },
      },
    },
    displayNone: {
      display: 'none !important',
    },
    footer: {
      display: 'block',
      textAlign: 'left',
      marginTop: '4.438rem',
      position: 'relative',
      minWidth: '12rem',
      [theme.breakpoints.up('md')]: {
        marginTop: '4.125rem',
        paddingBottom: '2rem',
      },
    },
    footerBack: {
      width: '100%',
      paddingLeft: '1rem',
    },
    footerNext: {
      width: '100%',
      textAlign: 'right',
      paddingRight: '1rem',
    },
    backBtn: {
      borderRadius: '2rem',
      wordSpacing: '0.425rem',
      letterSpacing: '0.15rem',
      border: '2px solid',
      marginLeft: 0,
      fontSize: '0.813rem',
      fontWeight: 'bold',
      background: theme.palette.background.paper,
      borderColor: theme.palette.primary.main,
      '&:hover': {
        border: '2px solid',
        background: theme.palette.primary.main,
        borderColor: theme.palette.background.paper,
        color: theme.palette.background.paper,
      },
      [theme.breakpoints.up('md')]: {
        padding: '0.438rem 1rem',
      },
    },
    flexColumn: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      '@media screen and (-ms-high-contrast: none)': {
        marginLeft: '1rem',
      },
    },
    gridColumns5: {
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
      msGridColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
      '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
        display: '-ms-flexbox',
      },
    },
    gridColumns6: {
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
      msGridColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns:
          'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr)',
      },
      '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
        display: '-ms-flexbox',
      },
    },
    '@media screen and (min-color-index:0) and (-webkit-min-device-pixel-ratio:0)': {
      '@media': {
        gridColumns5: {
          [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'auto !important',
          },
        },
        gridColumns6: {
          [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'auto !important',
          },
        },
      },
    },

    IEOnlyAnswers: {
      '@media screen and (-ms-high-contrast: none)': {
        marginRight: '1rem',
        flexGrow: 1,
        flexBasis: '50px',
      },
    },

    backArrowIcon: {
      marginLeft: '-0.313rem',
      marginRight: '0.313rem',
    },
    nextArrowIcon: {
      marginLeft: '0.313rem',
      marginRight: '-0.313rem',
    },
    errorAlert: {
      margin: '2rem 1rem',
    },
    alignLeft: {
      textAlign: 'left',
      flex: 'auto',
    },
    alignRight: {
      textAlign: 'right',
      flex: 'auto',
    },
    noOutline: {
      outline: 'none',
    },
    questionContainer: {
      minHeight: '16.875rem',
    },
    competencyName: {
      paddingBottom: '1.4rem',
      fontWeight: 700,
      fontSize: '1rem',
      color: theme.palette.default?.main || BrandColors.black,
    },
    btnDisabled: {
      pointerEvents: 'none',
    },
  }),
);

export const RatingAnswerButtonStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '-webkit-fill-available',
      height: '3rem',
      borderRadius: 8,
      fontWeight: 'bolder',
      padding: '0px',
      minWidth: '3rem',
      '@media screen and (device-aspect-ratio: 40/71) and (device-width : 320px)': {
        minWidth: '2.7rem',
        height: '2.7rem',
      },
      boxShadow: '0 8px 20px rgb(0 0 0 / 8%)',
      background: theme.palette.background.paper,
      border: `2px solid ${theme.palette.borderColor?.main || BrandColors.transparent}`,
      color: theme.palette.default?.main,
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.background.paper,
      },
      [theme.breakpoints.up('md')]: {
        height: '6rem',
        width: '100%',
        minWidth: '6rem',
        '&:hover': {
          color: theme.palette.secondary.contrastText,
          background: theme.palette.primary.contrastText,
        },
      },
      '&:focus-visible': {
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.secondary.contrastText,
      },
      '&:active': {
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.secondary.contrastText,
      },
      '&.btnSelected': {
        backgroundColor: 'transparent',
        color: lighten(theme.palette.default?.main || theme.palette.secondary.contrastText, 0.8),
      },
      '&.submitLoaderIcon': {
        display: 'none',
      },
      '&.btnSelected .submitLoaderIcon': {
        display: 'block',
      },
    },
    selected: {
      color: theme.palette.secondary.contrastText,
      background: theme.palette.primary.contrastText,
    },
    error: {
      border: '1px solid',
      borderColor: BrandColors.red39,
    },
    label: {
      height: '1.74em',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: '3rem',
        lineHeight: '100%',
      },
    },
    labelIcon: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: '3rem',
      },
    },
    text: {
      fontWeight: 600,
      color: theme.palette.default?.main,
      marginTop: '1.2rem',
      display: 'block',
      '& .wordBreak': {
        wordBreak: 'break-word',
      },
      '& .itemLabel0': {
        display: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '1.12rem',
        lineHeight: '128%',
        '& .itemLabel0': {
          display: 'block',
        },
      },
    },
    textAlignLeft: {
      textAlign: 'left',
      minWidth: '3.12rem',
    },
    textAlignRight: {
      textAlign: 'right',
      [theme.breakpoints.up('sm')]: {
        marginRight: '-1rem',
      },
      [theme.breakpoints.up('md')]: {
        marginRight: '0',
      },
    },
    submitButtonLoader: {
      color: theme.palette.primary.contrastText,
      position: 'absolute',
      display: 'none',
    },
  }),
);
